__turbopack_context__.v({
  "ant-modal-body": "TShZGq_ant-modal-body",
  "ant-modal-content": "TShZGq_ant-modal-content",
  "bgModal": "TShZGq_bgModal",
  "btn": "TShZGq_btn",
  "btnFooter": "TShZGq_btnFooter",
  "btnPosition": "TShZGq_btnPosition",
  "card": "TShZGq_card",
  "cards": "TShZGq_cards",
  "content": "TShZGq_content",
  "divbtn": "TShZGq_divbtn",
  "gridContainer": "TShZGq_gridContainer",
  "gridItem": "TShZGq_gridItem",
  "headContact": "TShZGq_headContact",
  "p": "TShZGq_p",
  "p1": "TShZGq_p1",
  "page-body-wrap": "TShZGq_page-body-wrap",
  "paragraph": "TShZGq_paragraph",
  "paragraph-content": "TShZGq_paragraph-content",
  "slider": "TShZGq_slider",
  "sosmed": "TShZGq_sosmed",
  "store": "TShZGq_store",
  "t": "TShZGq_t",
  "title": "TShZGq_title",
  "wrap-container": "TShZGq_wrap-container",
  "wrap-content": "TShZGq_wrap-content",
});
